import React, { useState } from 'react';
import { FaEye, FaCode, FaTimes } from 'react-icons/fa';

const HTMLPreview = ({ content, title = "Content Preview" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [viewMode, setViewMode] = useState('preview'); // 'preview' or 'html'

    if (!content || content.trim() === '') {
        return null;
    }

    return (
        <>
            {/* Preview Button */}
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors"
            >
                <FaEye size={14} />
                Preview Content
            </button>

            {/* Modal */}
            {isOpen && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        {/* Backdrop */}
                        <div
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                            onClick={() => setIsOpen(false)}
                        ></div>

                        {/* Modal Panel */}
                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
                            {/* Header */}
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="flex items-center justify-between mb-4">
                                    <h3 className="text-lg font-medium text-gray-900">
                                        {title}
                                    </h3>
                                    <div className="flex items-center gap-2">
                                        {/* View Mode Toggle */}
                                        <div className="flex rounded-md shadow-sm">
                                            <button
                                                type="button"
                                                onClick={() => setViewMode('preview')}
                                                className={`px-3 py-2 text-sm font-medium border ${viewMode === 'preview'
                                                        ? 'bg-primary text-white border-primary'
                                                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                                                    }`}
                                            >
                                                <FaEye size={14} className="inline mr-1" />
                                                Preview
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setViewMode('html')}
                                                className={`px-3 py-2 text-sm font-medium border-t border-r border-b ${viewMode === 'html'
                                                        ? 'bg-primary text-white border-primary'
                                                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                                                    }`}
                                            >
                                                <FaCode size={14} className="inline mr-1" />
                                                HTML
                                            </button>
                                        </div>

                                        {/* Close Button */}
                                        <button
                                            type="button"
                                            onClick={() => setIsOpen(false)}
                                            className="ml-2 p-2 text-gray-400 hover:text-gray-600 transition-colors"
                                        >
                                            <FaTimes size={16} />
                                        </button>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="max-h-96 overflow-y-auto">
                                    {viewMode === 'preview' ? (
                                        <div
                                            className="prose prose-sm max-w-none"
                                            dangerouslySetInnerHTML={{ __html: content }}
                                        />
                                    ) : (
                                        <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto">
                                            <code>{content}</code>
                                        </pre>
                                    )}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    onClick={() => setIsOpen(false)}
                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HTMLPreview;
